import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.jungleclick.online/api";

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json"
    }
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem("refreshToken");
                if (refreshToken) {
                    const response = await axios.post(API_BASE_URL + "/auth/refresh-token", {
                        refreshToken,
                    });

                    const { accessToken } = response.data;
                    localStorage.setItem("accessToken", accessToken);
                    originalRequest.headers["Authorization"] = "Bearer " + accessToken;
                    return apiClient(originalRequest);
                }
            } catch (refreshError) {
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export const getAccounts = async () => {
    try {
        const response = await apiClient.get("/accounts");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading accounts");
    }
}

export const getProfiles = async () => {
    try {
        const response = await apiClient.get("/accounts/profiles");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading profiles");
    }
}

export const getUsers = async () => {
    try {
        const response = await apiClient.get("/users");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading users");
    }
}

export const registerNewUser = async (userData) => {
    try {
        const response = await apiClient.post("/register", userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error registering user");
    }
}

export const registerUser = async (userData) => {
    try {
        const response = await apiClient.post("/auth/register", userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error registering user");
    }
};

export const loginUser = async (credentials) => {
    try {
        const response = await apiClient.post("/auth/login", credentials);
        if (response.data.accessToken)
            localStorage.setItem("accessToken", response.data.accessToken);
        if (response.data.refreshToken)
            localStorage.setItem("refreshToken", response.data.refreshToken);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error signing in");
    }
};

export const logoutUser = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
};

export const isAuthenticated = () => localStorage.getItem("accessToken");

export const getCurrentUser = async () => {
    try {
        const response = await apiClient.post("/auth/user");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading current user");
    }
};

export const getAssistantModels = async () => {
    try {
        const response = await apiClient.get('/ads-assistant/models');
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading assistant models");
    }
};

export const getUserToEdit = async (id) => {
    try {
        const response = await apiClient.get(`/getUserToEdit/${id}`);
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading user to edit");
    }
};

export const updateUser = async (userData, id) => {
    try {
        const response = await apiClient.put(`/updateUser/${id}`, userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error updating user");
    }
}

export const deleteUser = async (idUser) => {
    try {
        console.log(idUser);
        //para metodo delete de axios, el body se envia a partir de un campo "data"
        const response = await apiClient.delete(`/deleteUser`, { data: { id: idUser } });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error deleting user");
    }
};

export const restablecerContrasena = async (email, newPassword) => {
    try {
        const response = await apiClient.post("/restablecerContrasena", { email: email, newPassword: newPassword });
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error resetting password");
    }
}

export const getDailyReport = async (date, accountID) => {
    try {
        const response = await apiClient.get("/report/" + date + "/" + accountID);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading reports");
    }
};

export const updateReportAPI = async (data, reportId) => {
    try {
        const response = await apiClient.put("/report/update", { data: JSON.stringify(data), reportId: reportId });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error updating reports");
    }
}

export const getUpdateData = async (id) => {
    try {
        console.log("Entro");
        const response = await apiClient.get("/report/getUpdateData/" + id.toString());
        console.log(response);

        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading updated data");
    }
}

export const createParametro = async (data, id) => {
    try {
        const response = await apiClient.post("/parametros", { ...data, accountID: id });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error creating parameter");
    }
}

export const updateParametro = async (data, id) => {
    try {
        const response = await apiClient.put("/parametros/" + id, data);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error updating parameter");
    }
}

export const getParametros = async (id) => {
    try {
        const response = await apiClient.get("/parametros/list/" + id);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading parameters");
    }
}

export const getParametroByID = async (id) => {
    try {
        const response = await apiClient.get("/parametros/" + id);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading parameters");
    }
}

export const deleteParametro = async (id) => {
    try {
        const response = await apiClient.delete("/parametros/" + id);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error deleting parameter");
    }
}

export const getReportList = async (id) => {
    try {
        const response = await apiClient.get("/report/lista/" + id)
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading reports");
    }
};

export const getExpressList = async (id) => {
    try {
        const response = await apiClient.get("/express/lista/" + id)
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading terms");
    }
}

export const createExpress = async (data, id) => {
    try {
        console.log(data);
        const response = await apiClient.post("/express", { ...data, accountID: id })
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing terms");
    }
}

export const createSugerencia = async (data, account, date, user) => {
    try {
        const response = await apiClient.post("/sugerencias", { data: data, date: date, account: account, user: user });
        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error creating suggestion");
    }
}

export const getSugerencias = async () => {
    try {
        const response = await apiClient.get("/sugerencias");
        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading suggestions");
    }
}

export const getMergeReports = async (accountID) => {
    try {
        const response = await apiClient.get("/report/mergeReports/" + accountID);
        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error loading reports");
    }
}

export const createMergeReport = async (data, accountID) => {
    try {
        const response = await apiClient.post("/report/mergeReports/" + accountID, data);
        console.log(response.data);

        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error creating report");
    }
}

export const processReportsAPI = async (accountID, date, type) => {
    try {
        const response = await apiClient.post("/report/regenerate/" + accountID, {
            date: date,
            type: type
        });
        console.log(response.data);

        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error creating report");
    }
}

export const getLastReportDateAPI = async (accountID) => {
    try {
        const response = await apiClient.get("/report/last-date/" + accountID);
        return response.data;
    } catch (error) {
        console.error("Error fetching last report date:", error);
        return { success: false, lastDate: null };
    }
};

export default apiClient;